import React from 'react'
import { Routes, Route } from 'react-router-dom'
import { Login } from '../pages/Login'
import { AdminDashboard } from '../pages/AdminDashboard'
import { SuperAdminPage } from '../pages/SuperAdminPage'
import { NotFound } from '../pages/NotFound'
import { ProtectedRoute } from './ProtectedRoute'
import { ColorBlockJamDashboard } from '../pages/ColorBlockJamDashboard'
import { AdjustConfigPage } from '../pages/AdjustConfigPage'

const AppRoutes = () => {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />

      <Route
        path="/admin"
        element={
          <ProtectedRoute allowedRoles={['admin', 'super-admin']}>
            <AdminDashboard />
          </ProtectedRoute>
        }
      />
      <Route
        path="/adjust-config"
        element={
          <ProtectedRoute allowedRoles={['admin', 'super-admin']}>
            <AdjustConfigPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/super-admin"
        element={
          <ProtectedRoute allowedRoles={['super-admin']}>
            <SuperAdminPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/color-block-jam"
        element={
          <ProtectedRoute allowedRoles={['admin', 'super-admin']}>
            <ColorBlockJamDashboard />
          </ProtectedRoute>
        }
      />
      <Route
        path="/"
        element={
          <ProtectedRoute>
            <AdminDashboard />
          </ProtectedRoute>
        }
      />
      <Route path="*" element={<NotFound />} />
    </Routes>
  )
}

export default AppRoutes
